import React, { memo } from 'react'
import cardStyles from '../cards.scss'
import styles from './DisabledCard.scss'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const DisabledCard = memo(({
    title,
    text,
}) => {
    return (
        <div className={classNames(cardStyles.card, styles.base)}>
            <h2>{title}</h2>
            <p>{text}</p>
        </div>
    )
})

DisabledCard.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
}

export default DisabledCard



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/DisabledCard/DisabledCard.jsx